import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'letters',
  size: 24,
  node: [
    ['path', { d: 'M15 8H9', key: '1wjlh6' }],
    ['path', { d: 'M21 15.354a4 4 0 100 5.292', key: '1p5awo' }],
    [
      'path',
      {
        d: 'M3 18h4a2 2 0 010 4H3.5a.5.5 0 01-.5-.5v-7a.5.5 0 01.5-.5H6a2 2 0 010 4',
        key: '1pg2jz',
      },
    ],
    ['path', { d: 'm8 10 3.453-7.648a.6.6 0 011.094 0L16 10', key: '1spis8' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Letters
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgOEg5IiAvPgogIDxwYXRoIGQ9Ik0yMSAxNS4zNTRhNCA0IDAgMTAwIDUuMjkyIiAvPgogIDxwYXRoIGQ9Ik0zIDE4aDRhMiAyIDAgMDEwIDRIMy41YS41LjUgMCAwMS0uNS0uNXYtN2EuNS41IDAgMDEuNS0uNUg2YTIgMiAwIDAxMCA0IiAvPgogIDxwYXRoIGQ9Im04IDEwIDMuNDUzLTcuNjQ4YS42LjYgMCAwMTEuMDk0IDBMMTYgMTAiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/letters
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Letters = createLucideIcon(__iconData);

export default Letters;
